import type { FC, SVGProps } from 'react';

export const RainbowKitLogo: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <path
      fill="url(#a)"
      d="M0 0h40.136v40.136H0z"
      style={{
        fill: 'url(#a)',
        strokeWidth: 0.334469,
      }}
    />
    <path
      fill="url(#paint1_radial_62_329)"
      d="M6.69 12.71h2.006c10.345 0 18.73 8.386 18.73 18.73v2.007h4.014a2.007 2.007 0 0 0 2.007-2.007c0-13.67-11.081-24.75-24.75-24.75a2.007 2.007 0 0 0-2.008 2.006z"
      style={{
        fill: '#ff4000',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#b)"
      d="M28.095 31.44h5.352a2.007 2.007 0 0 1-2.007 2.007h-3.345z"
      style={{
        fill: '#ff4000',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#c)"
      d="M8.696 6.69v5.35H6.69V8.697c0-1.108.899-2.007 2.007-2.007z"
      style={{
        fill: '#ff4000',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#d)"
      d="M6.69 12.04h2.006c10.714 0 19.4 8.686 19.4 19.4v2.007h-6.021V31.44c0-7.389-5.99-13.379-13.379-13.379H6.69Z"
      style={{
        fill: '#fff700',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#e)"
      d="M22.744 31.44h5.351v2.007h-5.351z"
      style={{
        fill: '#fff700',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#f)"
      d="M6.69 17.392v-5.351h2.006v5.351z"
      style={{
        fill: '#fff700',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#g)"
      d="M6.69 20.737c0 1.108.898 2.007 2.006 2.007a8.696 8.696 0 0 1 8.696 8.696c0 1.108.899 2.007 2.007 2.007h3.345V31.44c0-7.758-6.29-14.048-14.048-14.048H6.69Z"
      style={{
        fill: '#01da40',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#h)"
      d="M17.392 31.44h5.352v2.007h-3.345a2.007 2.007 0 0 1-2.007-2.007z"
      style={{
        fill: '#01da40',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <path
      fill="url(#i)"
      d="M8.696 22.744a2.007 2.007 0 0 1-2.007-2.007v-3.345h2.007z"
      style={{
        fill: '#01da40',
        strokeWidth: 0.334469,
        fillOpacity: 1,
      }}
    />
    <defs>
      <linearGradient
        id="a"
        x1={60}
        x2={60}
        y1={0}
        y2={120}
        gradientTransform="scale(.33447)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#174299" />
        <stop offset={1} stopColor="#001E59" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={83}
        x2={100}
        y1={97}
        y2={97}
        gradientTransform="scale(.33447)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#FF4000" />
        <stop offset={1} stopColor="#8754C9" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={23}
        x2={23}
        y1={20}
        y2={37}
        gradientTransform="scale(.33447)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8754C9" />
        <stop offset={0} stopColor="#FF4000" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={68}
        x2={84}
        y1={97}
        y2={97}
        gradientTransform="scale(.33447)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF700" />
        <stop offset={1} stopColor="#FF9901" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={23}
        x2={23}
        y1={52}
        y2={36}
        gradientTransform="scale(.33447)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFF700" />
        <stop offset={1} stopColor="#FF9901" />
      </linearGradient>
      <radialGradient
        id="d"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-90 20.068 11.372) scale(19.39922)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={1} stopColor="#FFF700" />
        <stop offset={1} stopColor="#FF9901" />
      </radialGradient>
      <radialGradient
        id="g"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="rotate(-90 20.068 11.372) scale(14.04771)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0AF" />
        <stop offset={0} stopColor="#01DA40" />
      </radialGradient>
      <radialGradient
        id="h"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(5.68598 0 0 15.1626 17.058 32.444)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0AF" />
        <stop offset={0} stopColor="#01DA40" />
      </radialGradient>
      <radialGradient
        id="i"
        cx={0}
        cy={0}
        r={1}
        gradientTransform="matrix(0 -5.68598 107.82288 0 7.693 23.078)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#0AF" />
        <stop offset={0} stopColor="#01DA40" />
      </radialGradient>
    </defs>
  </svg>
);
